import script from "./DashboardGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardGrid.vue?vue&type=script&setup=true&lang=js"

import "./DashboardGrid.vue?vue&type=style&index=0&id=bbed8958&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbed8958"]])

export default __exports__